import React from 'react';
import { Bell } from 'lucide-react';
import './NoticeBell.css';

const NoticeBell = ({ unreadCount, onClick }) => {
  return (
    <button className="notice-bell-wrapper" onClick={onClick} aria-label="Notices">
      <Bell 
        size={26} 
        color="var(--text-dark, #0f172a)" 
        fill={unreadCount > 0 ? "var(--text-dark, #0f172a)" : "none"} 
      />
      
      {unreadCount > 0 && (
        <span className="notice-badge">
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      )}
    </button>
  );
};

export default NoticeBell;